<template>
  <div>
    <span>
      <div class="md-layout">
        <div class="md-layout-item ml-auto">
          <md-button
            class="md-warning"
            style="float: right;"
            @click="filterDialog = true"
          >
            <v-icon
              style="color: black !important; padding-right: 4px;"
            >
              filter_list
            </v-icon>
            <span style="color: black">
              {{$t('analysisPerServiceDeliveredFilter.filter')}}
            </span>
          </md-button>
        </div>
      </div>

      <GlobalDialog
        v-model='filterDialog'
        class="global-dialog-footer-buttons"
        max-width='700px'
        scrollable
        :headerTitle="$t('analysisPerServiceDeliveredFilter.filtersTitle')"
        showMButton
        mButtonTextColor='#FE544F'
        mButtonColor='#FE544F'
        mButtonIsOutlined
        :lButtonTitle="$t('analysisPerServiceDeliveredFilter.cancel')"
        :mButtonTitle="$t('analysisPerServiceDeliveredFilter.redefine')"
        @clickMButton='resetFilter()'
        showRButton
        :rButtonTitle="$t('analysisPerServiceDeliveredFilter.apply')"
        @clickRButton='saveFilter()'
      >
        <template v-slot:content>
          <AnalysisPerServiceDeliveredFilter key='resetKey'/>
        </template>
      </GlobalDialog>
    </span>

    <template>
      <!-- Performance By Service -->
      <PerfomanceByService/>
    </template>

    <template>
      <!-- Search Result -->
      <AnalysisPerServiceDeliveredResultTable ref='chat-table-reference'/>
    </template>
  </div>
</template>

<script>
import GlobalDialog from '@/components/Reuse/GlobalDialog'
import AnalysisPerServiceDeliveredFilter from '@/components/Filters/AnalysisPerServiceDeliveredFilter'
import PerfomanceByService from '@/components/PerformanceByService'
import AnalysisPerServiceDeliveredResultTable from '@/components/AnalysisPerServiceDeliveredResultTable/Search.vue'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import { mapFields } from 'vuex-map-fields'

export default {
  components: {
    GlobalDialog,
    AnalysisPerServiceDeliveredFilter,
    PerfomanceByService,
    AnalysisPerServiceDeliveredResultTable
  },
  mixins: [isTenantMixin],
  computed: {
    ...mapFields('analysisPerServiceDeliveredFilter', ['citizensCPF', 'service', 'returnCode']),
    ...mapFields('reports', ['dateInterval'])
  },
  data () {
    return {
      filterDialog: false,
      createButton: require('@/../public/img/plus.png'),
      resetKey: 0
    }
  },
  methods: {
    saveFilter () {
      this.filterDialog = false
      this.$refs['chat-table-reference'].changeFilters()
    },
    resetFilter () {
      this.citizensCPF = undefined
      this.service = undefined
      this.returnCode = undefined
      this.resetKey++

      this.saveFilter()
    }
  }
}
</script>

<style lang="scss" scoped>

::v-deep .ct-series-a .ct-slice-donut{
  stroke: #365EB4;
}
::v-deep .percentChartInss .ct-label {
  fill: rgb(255, 255, 255);
  font-weight: 600;
}
::v-deep .ct-series-b .ct-bar {
    stroke: #365EB4;
}

::v-deep .ct-series-a {
  .ct-bar{
    stroke: #E44C37;
  }
  .ct-label{
    stroke: #E44C37;
  }
}

</style>
